// 'exam' namespace — keys are prefixed 'exam.'. Russian is the primary UI language.
const ru: Record<string, string> = {
  'exam.title': 'Пробный экзамен',
  'exam.subtitle': 'Два письменных задания с таймером — как на экзамене A2, но для тренировки.',
  'exam.setup': 'Выбор формата',
  'exam.loading': 'Открываем экзамен…',
  'exam.notOfficial': 'Учебный формат A2. Не официальный экзамен; формат конкретной экзаменационной комиссии не подтверждён.',
  'exam.officialProfile': 'Формат сверен с первоисточником',
  'exam.verifiedAt': 'Проверено: {date}',
  'exam.source': 'источник',
  'exam.tasks': 'Заданий',
  'exam.timeLimit': 'Время',
  'exam.rubricTotal': 'Максимум',
  'exam.minutesN': '{n} мин',
  'exam.pointsN': '{n} балл.',
  'exam.structure': 'Структура',
  'exam.taskN': 'Задание {n}',
  'exam.taskShort': 'Задание',
  'exam.wordLimitsNote': 'У каждого задания свой лимит слов — он показан рядом с формулировкой.',
  'exam.rubric': 'Критерии учебной шкалы',
  'exam.hiddenUntilSubmit': 'Во время экзамена подсказки, образцы и проверка ИИ скрыты. Распознавание и оценка начнутся только после отправки обоих заданий.',
  'exam.modeLabel': 'Режим',
  'exam.timed': 'С таймером',
  'exam.untimed': 'Без таймера',
  'exam.untimedShort': 'Без таймера',
  'exam.timedHint': 'Таймер на {n} мин идёт на сервере: перезагрузка или потеря сети его не сбрасывают.',
  'exam.untimedHint': 'Тренировочный режим без ограничения времени — например, если нужно больше времени на письмо.',
  'exam.start': 'Начать экзамен',
  'exam.startNeedsNetwork': 'Чтобы начать экзамен, нужна сеть — задания и время начала фиксируются на сервере.',
  'exam.finishActiveFirst': 'Сначала завершите начатый экзамен.',
  'exam.noProfiles': 'Форматы экзамена не настроены',
  'exam.noProfilesText': 'Администратор ещё не добавил ни одного профиля экзамена.',
  'exam.activeTitle': 'Экзамен идёт',
  'exam.activeTimedText': 'Время продолжает идти, даже если приложение закрыто.',
  'exam.activeUntimedText': 'Тренировка без таймера — продолжайте, когда удобно.',
  'exam.resume': 'Продолжить экзамен',
  'exam.conflictTitle': 'У вас уже есть начатый экзамен',
  'exam.conflictText': 'Новый экзамен можно начать только после отправки текущего. Открыть его?',
  'exam.past': 'Прошлые экзамены',
  'exam.noPast': 'Пока нет завершённых экзаменов',
  'exam.noPastText': 'После отправки здесь появится учебный результат по каждому заданию.',
  'exam.submittedOn': 'Сдано {date}',
  'exam.status.active': 'Идёт',
  'exam.status.submitted': 'Сдано',
  'exam.status.expired': 'Время вышло',
  'exam.stillChecking': 'ещё проверяется',
  'exam.wordsN': 'слов: {n}',
  'exam.total': 'Итого',
  'exam.reportPending': 'Итог появится, когда будут проверены оба задания. Если распознанный текст ждёт вашего подтверждения — откройте задание.',
  'exam.practiceResult': 'Учебный результат',
  'exam.notFound': 'Экзамен не найден',
  'exam.notFoundText': 'Возможно, ссылка устарела или экзамен принадлежит другому пользователю.',
  'exam.backToExams': 'К экзаменам',
  'exam.submittedText': 'Работа отправлена. Распознавание и оценка идут в фоне — результаты появятся ниже.',
  'exam.expiredText': 'Время вышло: сохранено то, что успело синхронизироваться с сервером. Результаты появятся ниже.',
  'exam.noTasks': 'В этом экзамене нет заданий',
  'exam.tasksNav': 'Задания экзамена',
  'exam.sync.synced': 'сохранено на сервере',
  'exam.sync.saved_local': 'сохранено на устройстве',
  'exam.sync.syncing': 'синхронизация',
  'exam.sync.offline': 'нет сети, сохранено на устройстве',
  'exam.sync.conflict': 'конфликт версий',
  'exam.sync.error': 'ошибка синхронизации',
  'exam.sync.locked': 'закрыто для правки',
  'exam.timeLeftAria': 'Осталось примерно {m} мин',
  'exam.warnN': 'Осталось {n} минут',
  'exam.warn1': 'Осталась одна минута — работа отправится автоматически',
  'exam.offlineContinue': 'Нет сети. Пишите дальше — страницы сохраняются на устройстве, таймер идёт.',
  'exam.openedOffline': 'Экзамен открыт из копии на устройстве. Таймер идёт по времени сервера.',
  'exam.submit': 'Сдать экзамен',
  'exam.submitTitle': 'Сдать экзамен?',
  'exam.submitText': 'Все задания ({n}) отправятся вместе, одним действием. После этого рукопись фиксируется и больше не редактируется.',
  'exam.submitEmptyWarn': 'В задании {tasks} на этом устройстве пока ничего не написано.',
  'exam.submitConfirm': 'Сдать оба задания',
  'exam.keepWriting': 'Продолжить писать',
  'exam.submitNeedsNetwork': 'Для отправки нужна сеть. Продолжайте писать — всё сохраняется на устройстве; отправьте, когда связь вернётся.',
  'exam.submittedToast': 'Экзамен отправлен',
  'exam.notSyncedTitle': 'Не все страницы на сервере',
  'exam.notSyncedText': 'Часть страниц ещё не синхронизирована (или есть конфликт версий). Экзамен отправляется целиком, поэтому дождитесь синхронизации и попробуйте снова.',
  'exam.timeUpTitle': 'Время вышло — отправляем работу',
  'exam.timeUpText': 'Синхронизируем последние штрихи и отправляем оба задания. Не закрывайте приложение.',
  'exam.timeUpOffline': 'Нет связи с сервером. Сервер сам завершит экзамен с тем, что успело синхронизироваться до окончания времени. Когда сеть вернётся, мы повторим отправку автоматически.',
};

const en: Record<string, string> = {
  'exam.title': 'Mock exam',
  'exam.subtitle': 'Two timed writing tasks, A2-style — for practice.',
  'exam.setup': 'Choose a format',
  'exam.loading': 'Opening the exam…',
  'exam.notOfficial': 'A2 practice format. Not an official exam; the format of any specific exam board has not been verified.',
  'exam.officialProfile': 'Format checked against the primary source',
  'exam.verifiedAt': 'Verified: {date}',
  'exam.source': 'source',
  'exam.tasks': 'Tasks',
  'exam.timeLimit': 'Time',
  'exam.rubricTotal': 'Maximum',
  'exam.minutesN': '{n} min',
  'exam.pointsN': '{n} pts',
  'exam.structure': 'Structure',
  'exam.taskN': 'Task {n}',
  'exam.taskShort': 'Task',
  'exam.wordLimitsNote': 'Each task keeps its own word limit — shown next to its prompt.',
  'exam.rubric': 'Practice rubric criteria',
  'exam.hiddenUntilSubmit': 'During the exam, hints, model texts and AI checking are hidden. Recognition and scoring start only after both tasks are submitted.',
  'exam.modeLabel': 'Mode',
  'exam.timed': 'Timed',
  'exam.untimed': 'Untimed',
  'exam.untimedShort': 'Untimed',
  'exam.timedHint': 'The {n}-minute timer runs on the server: reloading or losing connection does not reset it.',
  'exam.untimedHint': 'Practice without a time limit — for example if you need extra time to write.',
  'exam.start': 'Start exam',
  'exam.startNeedsNetwork': 'Starting an exam needs a connection — tasks and start time are recorded on the server.',
  'exam.finishActiveFirst': 'Finish your current exam first.',
  'exam.noProfiles': 'No exam formats configured',
  'exam.noProfilesText': 'The administrator has not added an exam profile yet.',
  'exam.activeTitle': 'Exam in progress',
  'exam.activeTimedText': 'Time keeps running even while the app is closed.',
  'exam.activeUntimedText': 'Untimed practice — continue whenever you like.',
  'exam.resume': 'Resume exam',
  'exam.conflictTitle': 'You already have an exam in progress',
  'exam.conflictText': 'You can start a new exam once the current one is submitted. Open it?',
  'exam.past': 'Past exams',
  'exam.noPast': 'No finished exams yet',
  'exam.noPastText': 'After submitting, a practice result for each task appears here.',
  'exam.submittedOn': 'Submitted {date}',
  'exam.status.active': 'In progress',
  'exam.status.submitted': 'Submitted',
  'exam.status.expired': 'Time ran out',
  'exam.stillChecking': 'still checking',
  'exam.wordsN': '{n} words',
  'exam.total': 'Total',
  'exam.reportPending': 'The total appears once both tasks are scored. If a transcript is waiting for your confirmation, open the task.',
  'exam.practiceResult': 'Practice result',
  'exam.notFound': 'Exam not found',
  'exam.notFoundText': 'The link may be outdated, or the exam belongs to someone else.',
  'exam.backToExams': 'Back to exams',
  'exam.submittedText': 'Submitted. Recognition and scoring run in the background — results appear below.',
  'exam.expiredText': 'Time ran out: whatever had synced to the server was kept. Results appear below.',
  'exam.noTasks': 'This exam has no tasks',
  'exam.tasksNav': 'Exam tasks',
  'exam.sync.synced': 'saved on the server',
  'exam.sync.saved_local': 'saved on this device',
  'exam.sync.syncing': 'syncing',
  'exam.sync.offline': 'offline, saved on this device',
  'exam.sync.conflict': 'version conflict',
  'exam.sync.error': 'sync error',
  'exam.sync.locked': 'locked',
  'exam.timeLeftAria': 'About {m} min left',
  'exam.warnN': '{n} minutes left',
  'exam.warn1': 'One minute left — your work will be submitted automatically',
  'exam.offlineContinue': 'Offline. Keep writing — pages are saved on this device and the timer keeps running.',
  'exam.openedOffline': 'Exam opened from the copy on this device. The timer follows server time.',
  'exam.submit': 'Submit exam',
  'exam.submitTitle': 'Submit the exam?',
  'exam.submitText': 'All tasks ({n}) are submitted together, in one step. Afterwards the handwriting is frozen and can no longer be edited.',
  'exam.submitEmptyWarn': 'Nothing has been written on this device for task {tasks} yet.',
  'exam.submitConfirm': 'Submit both tasks',
  'exam.keepWriting': 'Keep writing',
  'exam.submitNeedsNetwork': 'Submitting needs a connection. Keep writing — everything is saved on this device; submit once you are back online.',
  'exam.submittedToast': 'Exam submitted',
  'exam.notSyncedTitle': 'Not all pages are on the server',
  'exam.notSyncedText': 'Some pages have not synced yet (or have a version conflict). The exam is submitted as a whole, so wait for sync and try again.',
  'exam.timeUpTitle': 'Time is up — submitting your work',
  'exam.timeUpText': 'Syncing the last strokes and submitting both tasks. Please keep the app open.',
  'exam.timeUpOffline': 'No connection to the server. The server will close the exam with whatever had synced before time ran out. We will retry automatically once you are back online.',
};

export default { ru, en };
